import React, { useState } from 'react';
import Typography from '@mui/material/Typography';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';

import type { ILead } from 'src/services/api';
import ExpandableItem from 'src/components/lead-sidebar/LeadSidebarExpandableItem';
import { FlexColumn } from 'src/components/flex';
import { CopyIcon } from 'src/icons';
import { copyToClipboard } from 'src/components/copy-text-button/utils';

dayjs.extend(relativeTime);

export default function LeadInfo({ lead }: { lead: ILead }) {
    const [isCopied, setCopied] = useState(false);

    const displayedUUID = lead.uuid.slice(0, 10) + '...';

    const handleCopy = async (text: string) => {
        const isSuccess = await copyToClipboard(text);
        if (isSuccess) {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        }
    };

    let title = 'Copy to clipboard';
    if (isCopied) {
        title = 'Copied';
    }

    return (
        <ExpandableItem title="Lead Info" defaultExpanded={false}>
            <FlexColumn gap={2}>
                <FlexColumn gap={0}>
                    <Typography variant="body2" sx={{ fontWeight: 600 }}>Reffie ID</Typography>
                    <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center' }}>
                        {displayedUUID}
                        <Tooltip title={title}>
                            <IconButton onClick={() => handleCopy(lead.uuid)}>
                                <CopyIcon />
                            </IconButton>
                        </Tooltip>
                    </Typography>
                </FlexColumn>
            </FlexColumn>
        </ExpandableItem>
    );
}
